export default __webpack_public_path__ + "static/media/Cont-1.8f510b94.jpg";